// TES-1111 — free-text search that knows renamed terms.
//
// PCOS was officially renamed PMOS (polyendokrint metabolt ovariesyndrom).
// Patient copy now says PMOS, but patients keep searching for the name they
// know. Emelie 2026-10-05: "Sökning ska hitta innehållet på både PMOS och
// PCOS." Stored keys (`course.nutrition.pcos_weight_treatment`, the `pcos`
// topic id, the `pcos` form value) are not touched — only the text a search
// compares is normalised.
//
// Each group lists the term copy uses first, then the names it replaced. Both
// the query and the searched text are folded onto the first term, so "PCOS"
// finds "Mat, PMOS och viktbehandling", "pmos" finds an older text that still
// says PCOS, and a compound such as "PCOS-kost" matches "PMOS-kost".
export const SEARCH_SYNONYM_GROUPS: ReadonlyArray<readonly string[]> = [
  ["pmos", "pcos"],
];

const FOLDS: ReadonlyArray<[RegExp, string]> = SEARCH_SYNONYM_GROUPS.flatMap(
  ([canonical, ...aliases]) =>
    aliases.map((alias): [RegExp, string] => [
      new RegExp(alias, "gi"),
      canonical,
    ]),
);

/** Lower-cased text with every alias folded onto its group's first term. */
export function normalizeForSearch(text: string): string {
  let out = text.toLocaleLowerCase();
  for (const [re, canonical] of FOLDS) out = out.replace(re, canonical);
  return out;
}

/**
 * True when `query` (trimmed, case-insensitive) occurs in `text`, treating
 * the terms of a synonym group as the same word. An empty query matches.
 */
export function matchesSearch(text: string, query: string): boolean {
  const q = normalizeForSearch(query.trim());
  if (!q) return true;
  return normalizeForSearch(text).includes(q);
}
